export enum ContactType {
    Email = 1,
    Sms = 2,
    Slack = 3,
    WhatsApp = 4,
}